import React from "react";
import Container from "../ui/Container";
import SectionHeading from "../ui/SectionHeading";
import GlassCard from "../ui/GlassCard";
import Icon from "../ui/Icon";
import { testimonials } from "../../data/testimonials";

const Testimonials = () => (
  <section className="bg-surface py-20 md:py-section-gap">
    <Container>
      <SectionHeading title="What Our Clients Say" className="mb-16" />
      <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {testimonials.map((t) => (
          <GlassCard key={t.name} className="flex flex-col p-8">
            <Icon
              name="format_quote"
              fill
              className="mb-4 text-4xl text-primary-container"
            />
            <p className="flex-grow font-body-md text-body-md leading-relaxed text-on-surface-variant">
              {t.quote}
            </p>
            <div className="mt-6 flex items-center gap-4">
              <img
                src={t.avatar}
                alt={t.name}
                className="h-14 w-14 rounded-full border-2 border-white object-cover shadow"
                loading="lazy"
              />
              <div>
                <h4 className="font-headline-lg-mobile text-base font-bold text-on-surface">
                  {t.name}
                </h4>
                <p className="font-label-sm text-label-sm font-bold uppercase text-primary-container">
                  {t.role}
                </p>
              </div>
            </div>
          </GlassCard>
        ))}
      </div>
    </Container>
  </section>
);

export default Testimonials;
